export const API_ROOT = 'https://rest.boxcast.com';
export const INTEGRATIONS_ROOT = 'https://integration.boxcast.com';
export const LOGIN_URL = 'https://login.boxcast.com';
export const AUTH_URL =
  'https://rest.boxcast.com/oauth2/auth?response_type=code&client_id=kgsyfw5lrhvrzu89gsaj&redirect_uri=https%3A%2F%2Fdashboard.boxcast.com%2F&scope=dashboard';
export const SWITCHER_AUTH_URL =
  'https://rest.boxcast.com/oauth2/auth?response_type=code&client_id=izon8vdwo6n9fvlrydfn&redirect_uri=https%3A%2F%2Fdashboard.boxcast.com%2F&scope=owner';
export const TOKEN_URL = 'https://rest.boxcast.com/oauth2/token';
export const LOGOUT_URL = 'https://rest.boxcast.com/oauth2/auth/sessions/login/revoke';
export const GEO_URL = 'https://geo.boxcast.com/json/';
export const BOXCAST_JS = '//js.boxcast.com/v3.min.js';
export const BOXCAST_JS_EMBED_URL = '//js.boxcast.com/v3.min.js';
export const WIDGET_JS = '//js.boxcast.com/v2.widget.js';
export const BOXCAST_SHOW_URL = 'https://boxcast.tv/channel/';
export const BOXCAST_TV_SHOW_URL = 'https://boxcast.tv/channel/';
export const BOXCAST_TV_HIGHLIGHT_URL = 'https://boxcast.tv/highlights/';
export const BOXCAST_TV_VIDEO_PORTAL_URL = 'https://boxcast.tv/video-portal/';
export const IMG_ROOT = 'https://dashboard.boxcast.com/img/';
export const BANDWIDTH_TEST_URL = 'https://w35c8wpq1bdd4z59brit.boxcast.com';
export const STRIPE_KEY = 'pk_live_UJ0NcpFDJTsAbVzzYkcohioj';
export const FACEBOOK_APP_ID = '1748343348730542';
export const YOUTUBE_CLIENT_ID =
  '272935062177-4207ghd9v3a0ldpuo4o4a35meu9duvfc.apps.googleusercontent.com';
export const YOUTUBE_OAUTH_REDIRECT = 'https://dashboard.boxcast.com?oauth_reply_from=youtube';
export const VIMEO_OAUTH_REDIRECT = 'https://dashboard.boxcast.com?oauth_reply_from=vimeo';
export const TWITTER_OAUTH_REDIRECT = 'https://dashboard.boxcast.com/#/settings/twitter';
export const DATADOG_LOGS_CLIENT_TOKEN = 'puba616154f05271b073ae9c7b73917e92c';
export const INTERCOM_APP_ID = 'n4ioj8zx';
export const CHURNZERO_APP_KEY = '1!Sw-b5h-HzZWfHO6BE4SCQz4QEghhWHmBMEvXDaeOYYotC65';

export const VUE_DASHBOARD_ROOT = 'https://dashboard.boxcast.com';
export const NG_DASHBOARD_ROOT = 'https://dashboard.boxcast.com';



// WEBPACK FOOTER //
// ./app/environments/prod.js